import React, {Component} from "react";
import {Layout, message, Menu} from "antd";
import Header from "../../components/header";
import {reqCaseDetail} from "../../api";

import './caseDetail.less';

const { Content,Sider } = Layout;

/**
 * 技能训练详情的路由组件
 */
export default class CaseDetail extends Component {
    state = {
        detailId:0,
        title:'',
        imgs:[],
        description:'',
        questions1: {},
        questions2: {},
        question1: '',
        question2: '',
        correct1:'',
        correct2:'',
        analysis1:'',
        analysis2:'',
        idArr:[],
        lastDetail:false,
        firstDetail:false

    };

    getCaseDetail = async (detailId) => {
        const result = await reqCaseDetail(detailId);
        if(result.code ==='000000') {
            const detailId = result.data.detailId;
            const title = result.data.title;
            const imgs = result.data.imgs;
            const description = result.data.description;
            const questions1 = result.data.questions[0];
            const questions2 = result.data.questions[1];
            const question1 = result.data.questions[0].question;
            const question2 = result.data.questions[1].question;
            const correct1 = result.data.questions[0].answer;
            const correct2 = result.data.questions[1].answer;
            this.setState({
                detailId:detailId,
                title:title,
                imgs:imgs,
                description:description,
                questions1 : questions1,
                questions2 : questions2,
                question1 : question1,
                question2 : question2,
                correct1 : correct1,
                correct2 : correct2
            });
        }else {
            message.error(result.msg);
        }
    };

    answerSubmit = () => {
        this.setState({
            btn_display:true
        });
        let check1 = document.getElementsByName("option1");
        let check2 = document.getElementsByName("option2");
        let choice1 = document.getElementsByName("choice1");
        let choice2 = document.getElementsByName("choice2");
        let correct1 = this.state.correct1;
        let correct2 = this.state.correct2;
        let answer1 = "";
        let answer2 = "";
        let options1 = this.state.questions1.options;
        let options2 = this.state.questions2.options;

       for (let i = 0; i < check1.length; i++) {
            if(check1[i].checked){
                answer1 = check1[i].value;
            }
           if(check2[i].checked){
               answer2 = check2[i].value;
           }
        }
        if(correct1===answer1) {
            this.setState({
                analysis1:'选择正确'
            });
        }else {
            this.setState({
                analysis1:'选择错误，正确答案是'+correct1
            });
        }
        if(correct2===answer2) {
            this.setState({
                analysis2:'选择正确'
            });
        }else {
            this.setState({
                analysis2:'选择错误，正确答案是'+correct2
            });
        }
        for (let i = 0; i < options1.length; i++) {
            if(correct1===options1[i].optionKey){
                choice1[i].setAttribute("class","success");
                if(answer1===options1[i].optionKey){
                    check1[i].checked=false;
                }
            }else if(answer1===options1[i].optionKey){
                check1[i].checked=false;
                choice1[i].setAttribute("class","error");
            }
            choice1[i].disabled = true;
            check1[i].disabled = true;
        }
        for (let i = 0; i < options2.length; i++) {
            if(correct2===options2[i].optionKey){
                choice2[i].setAttribute("class","success");
                if(answer2===options2[i].optionKey){
                    check2[i].checked=false;
                }
            }else if(answer2===options2[i].optionKey){
                check2[i].checked=false;
                choice2[i].setAttribute("class","error");
            }
            choice2[i].disabled = true;
            check2[i].disabled = true;
        }
    };

    prevCase = async () => {
        let detailId = sessionStorage.getItem("detailId");
        const idArr = this.state.idArr;
        let index = 0;
        for (let i = 0; i < idArr.length; i++) {
            if(detailId===idArr[i]){
                index = i;
                break;
            }
        }
        if(index>0){
            this.getCaseDetail(idArr[index-1]);
            sessionStorage.setItem("detailId",idArr[index-1]);
            this.setState({
                lastDetail:false,
            });
            if(index === 1){
                this.setState({
                    firstDetail:true
                })
            }
        }else {
            message.info("这是第一条");
        }
        this.clearChoice();
        window.scroll(0,0);
    };

    nextCase = async () => {
        this.setState({
            firstDetail:false
        });
        let detailId = sessionStorage.getItem("detailId");
        const idArr = this.state.idArr;
        let index = 0;
        for (let i = 0; i < idArr.length; i++) {
            if(detailId===idArr[i]){
                index = i;
                break;
            }
        }
        if(index<idArr.length-1){
            this.getCaseDetail(idArr[index+1]);
            sessionStorage.setItem("detailId",idArr[index+1]);
            if(index === idArr.length-2){
                this.setState({
                    lastDetail:true
                })
            }
        }else {
            message.info("这是最后一条");
        }
        this.clearChoice();
        window.scroll(0,0);
    };

    clearChoice (){
        let check1 = document.getElementsByName("option1");
        let check2 = document.getElementsByName("option2");
        let choice1 = document.getElementsByName("choice1");
        let choice2 = document.getElementsByName("choice2");
        for(let i=0;i<choice1.length;i++){
            choice1[i].setAttribute("class","");
            choice2[i].setAttribute("class","");
            choice1[i].disabled = false;
            choice2[i].disabled = false;
            check1[i].disabled = false;
            check2[i].disabled = false;
        }
        this.setState({
            analysis1:"",
            analysis2:"",
            btn_display:false
        });
    };

    toCase =(e)=>{
        this.props.history.goBack();
    };

    componentDidMount =async()=>{
        let detailId = sessionStorage.getItem("detailId");
        this.getCaseDetail(detailId);
        let idArr = sessionStorage.getItem("idArr").split(",");
        if(idArr[0] === detailId){
            this.setState({
                firstDetail:true,
            });
        }
        if(idArr[idArr.length-1] === detailId){
            this.setState({
                lastDetail :true,
            });
        }
        this.setState({
            idArr:idArr
        });
        document.getElementsByClassName("logo_t")[0].setAttribute("hidden",true);
    };

    render() {

        return (
            <Layout>
                <Header>Header</Header>
                <Layout>
                    <Sider className='case_left'>
                        <Menu style={{ width: 170 }} defaultSelectedKeys={['1']} defaultOpenKeys={['sub1']} mode={this.state.mode} theme={this.state.theme}>
                            <Menu.Item key="1" onClick={this.toCase.bind(this)}>
                                返回
                            </Menu.Item>
                        </Menu>
                    </Sider>
                    <Content>
                        <div className="detail case">
                            <div className="detail_content">
                                <div className="case_title">
                                    <h3>{this.state.title}</h3>
                                    <p>{this.state.description}</p>
                                </div>
                                <div className="details_left1">
                                    <div className="details_img">
                                        <img src={this.state.imgs?global.constant.baseUrl+'download/'+this.state.imgs[0]:require("../../assets/images/head.jpg")} className="img-responsive"/>
                                    </div>
                                    <div className="detail_change">
                                        <a className={this.state.firstDetail?'no_next':"prev"} onClick={this.prevCase}>上一题</a>
                                        <a className={this.state.lastDetail?'no_next':"next"} onClick={this.nextCase}>下一题</a>
                                    </div>
                                </div>
                                <div className="details_right">
                                    <div className="question">
                                        <div style={{height:'270px'}}>
                                            <div className="title">[1]{this.state.question1}：</div>
                                            <form>
                                                <div className="question_all">
                                                    {
                                                        this.state.questions1.options && this.state.questions1.options.map((option, index) => {
                                                            return (
                                                                <div className="que_checkbox" key={index}>
                                                                    <label>
                                                                        <input type="radio" name="option1" value={option.optionKey}/>
                                                                        <div name="choice1">{option.optionKey} {option.optionValue}</div>
                                                                    </label>
                                                                </div>
                                                            );
                                                        })
                                                    }
                                                </div>
                                            </form>
                                            <div className="tips">{this.state.analysis1}</div>
                                        </div>
                                        <div>
                                            <div className="title">[2]{this.state.question2}：</div>
                                            <form>
                                                <div className="question_all">
                                                    {
                                                        this.state.questions2.options && this.state.questions2.options.map((option, index) => {
                                                            return (
                                                                <div className="que_checkbox" key={index}>
                                                                    <label>
                                                                        <input type="radio" name="option2" value={option.optionKey}/>
                                                                        <div name="choice2">{option.optionKey} {option.optionValue}</div>
                                                                    </label>
                                                                </div>
                                                            );
                                                        })
                                                    }
                                                </div>
                                            </form>
                                            <div className="tips">{this.state.analysis2}</div>
                                        </div>
                                        <button type="button" className="btn_submit" hidden={this.state.btn_display} onClick={this.answerSubmit}>提交</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Content>
                </Layout>
            </Layout>
        )
    }
}